import React, { useState, useEffect } from "react";
import { useUserAuth } from "../../Context/UserAuthContext";
// import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import "./Login.css";
import { Logo1 } from "../../Assests/Assests";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  
  const navigate = useNavigate();
  const { login } = useUserAuth();


  


  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      navigate("/");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    const result = await login(email, password);


    if (!result.success) {
      toast.error(result.message || "An unknown error occurred!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return; // Exit early to prevent further execution
    }
  
    // Email verification check
    if (result.message === "Email is not verified") {
      toast.error(result.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      return; // Exit early to prevent success toast
    }
  
    // toast.success("Logged in successfully!", {
    //   position: "top-right",
    //   autoClose: 2000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   className: "custom-toast",
    //   bodyClassName: "custom-toast-body",
    //   onClose: () => navigate("/"), // Navigate after toast closes
    // });
      toast.success("Logged in successfully!", {
        autoClose: 4000,
      });
      navigate("/");
  };

  return (
    <div className="login-container">

      {/* Left — photo panel */}
      <div className="login-left">
        <img src="https://riymay.com/assets/about-hero.jpg" alt="Riymay" />
        <div className="login-left-overlay" />
        <span className="login-left-brand">Riymay</span>
        <div className="login-left-bottom">
          <div className="login-left-headline">Wear it<br />without<br />explanation.</div>
          <div className="login-left-sub">Premium unisex clothing</div>
        </div>
      </div>

      {/* Right — open form */}
      <div className="login-right">
        <form className="login-form-container" onSubmit={handleLogin}>
          <h1 className="login-heading">Login</h1>

          <div className="login-form-group">
            <input type="email" name="email" className="login-input" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>

          <div className="login-form-group">
            <input type={showPassword ? "text" : "password"} name="password" className="login-input" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <div className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </div>
          </div>

          <div className="login-links">
            <Link to="/forgot-password" className="login-Link">Forgot Password?</Link>
            <Link to="/register" className="login-signin">Sign Up</Link>
          </div>

          <button type="submit" className="login-button">Login</button>
        </form>
        <img src={Logo1} alt="" className="login-spinning-logo" />
      </div>

    </div>
  );
};

export default Login;
